import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { JwtService } from '../services/jwt.service';
import { SKIP_AUTH } from './http-context.tokens';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const jwtService = inject(JwtService);

  if (req.context.get(SKIP_AUTH)) {
    return next(req);
  }

  // Skip adding token for unauthenticated auth endpoints
  if (req.url.includes('/auth/login') || req.url.includes('/auth/set-password')) {
    return next(req);
  }

  let authReq = req;

  // Add device token header if exists and not expired
  if (jwtService.deviceToken && !jwtService.isDeviceTokenExpired()) {
    authReq = authReq.clone({
      headers: authReq.headers.set('X-Device-Token', jwtService.deviceToken),
    });
  }

  // Add employee token if user is logged in (real user)
  if (jwtService.isLogged() && jwtService.jwtToken) {
    authReq = authReq.clone({
      headers: authReq.headers.set('Authorization', `Bearer ${jwtService.jwtToken}`),
    });
  }

  return next(authReq);
};
